let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3VVOe")).then(() => parcelRequire('2ewqH'));